import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=05b06056&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.css?vue&type=style&index=0&id=05b06056&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b06056",
  null
  
)

export default component.exports